module.exports = __webpack_public_path__ + "assets/img/mecha-daa563b3.png";